import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const GroupFilters = ({ filters, onFilterChange, onReset }) => {
  const { t, currentLanguage } = useLanguage();

  const pilgrimageTypeOptions = [
    { value: '', label: t('groups.allTypes') },
    { value: 'Omra', label: t('groups.omra') },
    { value: 'Hajj', label: t('groups.hajj') }
  ];

  const capacityStatusOptions = [
    { value: '', label: t('groups.allStatuses') },
    { value: 'available', label: t('groups.available') },
    { value: 'filling', label: t('groups.filling') },
    { value: 'full', label: t('groups.full') }
  ];

  const monthOptions = [
    { value: '', label: t('groups.allMonths') },
    { value: '01', label: t('groups.january') },
    { value: '02', label: t('groups.february') },
    { value: '03', label: t('groups.march') },
    { value: '04', label: t('groups.april') },
    { value: '05', label: t('groups.may') },
    { value: '06', label: t('groups.june') },
    { value: '07', label: t('groups.july') },
    { value: '08', label: t('groups.august') },
    { value: '09', label: t('groups.september') },
    { value: '10', label: t('groups.october') },
    { value: '11', label: t('groups.november') },
    { value: '12', label: t('groups.december') }
  ];

  const nusukSyncOptions = [
    { value: '', label: t('groups.allSync') },
    { value: 'synced', label: t('groups.synced') },
    { value: 'pending', label: t('groups.pending') }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-warm p-4 md:p-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Filter" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">{t('common.filter')}</h3>
      </div>
      <div className="space-y-4">
        <Input
          type="search"
          placeholder={t('groups.searchPlaceholder')}
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          label={t('groups.filterByType')}
          options={pilgrimageTypeOptions}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
        />

        <Select
          label={t('groups.filterByStatus')}
          options={capacityStatusOptions}
          value={filters?.capacityStatus}
          onChange={(value) => onFilterChange('capacityStatus', value)}
        />

        <Select
          label={t('groups.allMonths')}
          options={monthOptions}
          value={filters?.month}
          onChange={(value) => onFilterChange('month', value)}
        />

        <Select
          label={t('groups.allSync')}
          options={nusukSyncOptions}
          value={filters?.nusukSync}
          onChange={(value) => onFilterChange('nusukSync', value)}
        />

        <div className="flex gap-3 pt-4">
          <Button
            variant="outline"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onReset}
            fullWidth
          >
            {t('common.cancel')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GroupFilters;